
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { List, ListItem } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`List`}</h1>
<p>{`Used to display items with bullet points or numbers. `}<inlineCode parentName="p">{`ordered`}</inlineCode>{` lists take over most of the items style, and make it all the same color, overriding `}<inlineCode parentName="p">{`category`}</inlineCode>{` and `}<inlineCode parentName="p">{`icon`}</inlineCode>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { List, ListItem } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<List>
  <ListItem>First item in the list</ListItem>
  <ListItem>Second item in the list</ListItem>
  <ListItem>Third item in the list</ListItem>
  <ListItem>Fourth item in the list</ListItem>
</List>`} component={List} mdxType="Playground">
  <List mdxType="List">
    <ListItem mdxType="ListItem">First item in the list</ListItem>
    <ListItem mdxType="ListItem">Second item in the list</ListItem>
    <ListItem mdxType="ListItem">Third item in the list</ListItem>
    <ListItem mdxType="ListItem">Fourth item in the list</ListItem>
  </List>
</Playground>
<h4>{`List item`}</h4>
<Playground __position={1} __code={`<List>
  <ListItem>Im an item of the list</ListItem>
</List>`} component={ListItem} mdxType="Playground">
  <List mdxType="List">
    <ListItem mdxType="ListItem">Im an item of the list</ListItem>
  </List>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;